import axios from "axios";
import { getConfig } from '../helpers/config';

export class IstruttorieService {

  baseAPIUrl = `${getConfig()?.url}istruttorie`;

  getAllDt = async (data) => {
    return await axios.post(`${this.baseAPIUrl}/allDt`, data).then(resp => resp.data);
  }

  valida = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await axios.post(`${this.baseAPIUrl}/valida`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Errore durante l'invio del file CSV:", error);
      throw error;
    }
  };

  importa = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await axios.post(
        `${this.baseAPIUrl}/importa`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Errore durante l'importazione del file CSV:", error);
      throw error;
    }
  };

  getUltimaImportazione = async () => {
    return await axios.get(`${this.baseAPIUrl}/latest`)
  }

  saveIstruttoriaArs = async (istruttoriaArs) => {
    return await axios.post(`${this.baseAPIUrl}/istruttoria-ars`, istruttoriaArs)
      .then((res) => res.data);
  }

  deleteIstruttoriaArs = async (id) => {
    return await axios.delete(`${this.baseAPIUrl}/${id}/istruttoria-ars`)
      .then((res) => res.data);
  }

  getAllUcsByBandoId = async (bandoId) => {
    return await axios.get(`${this.baseAPIUrl}/ucs/all/bando/${bandoId}`)
      .then((res) => res.data);
  }
}
